import React, { useContext } from 'react'
import { FormContext } from '../FormContext';
import { Col } from "react-bootstrap";
import "./customelements.css"

const DateTime = ({ id, label, placeholder, value, disabled, example, mandatory, md }) => {
    const { handleChange } = useContext(FormContext)
    return (
        <Col md={md} className="pad-trbl-10 custom-select-holder">
            <div className="mb-3">
                <label htmlFor="time" className="form-label move-left">{mandatory?<span style={{color:"red", marginRight: 5}}>*</span>:""}{label}</label>
                <input type="time" className="form-control move-left custom-input" id="time" aria-describedby="timeHelp"
                    placeholder={placeholder ? placeholder : ''}
                    value={value}
                    onChange={event => handleChange(id, event)}
                    disabled={disabled}
                    required={mandatory}
                    autoComplete="new-password"
                />
                <div id="timeHelp" className="text-muted move-left input-example">Example: {example}</div>
            </div>
        </Col>
    )
}

export default DateTime